export default __webpack_public_path__ + "images/logo-simecal-2026.e076ef295d8e5331589c11832d739566.png";